import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';
import { ContextResolver } from './questionnaire/context.resolver';

const routes: Routes = [
  { path: 'questionnaire/:groupement', component: QuestionnaireComponent, resolve: { context: ContextResolver } },
  { path: '', redirectTo: '/questionnaire/demo', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }